module.exports = __webpack_public_path__ + "img/HeySong_Car_step03_2.6f8ea34c.png";